import * as React from 'react';
import { EditModeEnum } from '../interfaces/state';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';
import { GlobalHotKeys } from 'react-hotkeys';
import { OnIgnoreEnter } from '../AnalyseApp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faLocationPin } from '@fortawesome/free-solid-svg-icons';

interface AddEventButtonProps {
    isVisible: boolean;
    isEditMode: EditModeEnum;
    isPlaying: boolean;
    isKeyboardShortcutVisible: boolean;
    onAddClick: () => void;
    onConfirmPointClick: () => void;
    onConfirmPeriodClick: () => void;
    isDisabled: boolean;
}

export const AddEventButton = (props: AddEventButtonProps) => {


    const onConfirmClick = (e?: any): void => {
        if (e) {
            e.target.blur();
        }

        //If the button is not visible (I.e. in view only mode),
        //then the user should not be able to add any events.
        if (!props.isVisible) {
            return;
        }

        if (props.isEditMode == EditModeEnum.NotEditing) {
            props.onAddClick();
        } else if (props.isEditMode == EditModeEnum.EditingPoint) {
            props.onConfirmPointClick();
        } else if (props.isEditMode == EditModeEnum.EditingPeriod) {
            props.onConfirmPeriodClick();
        }
    }

    if (props.isVisible) {
        const keyMap = {
            addEvent: 'enter',
        }

        const handlers = {
            'addEvent': () => {
                if (!props.isPlaying && !props.isDisabled) {
                    onConfirmClick();
                }
            }
        }

        if (props.isEditMode === EditModeEnum.NotEditing) {
            return (
                <>
                    <GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />
                    <button id="AddEvent" className="btn btn-primary" type="button" disabled={props.isDisabled || props.isPlaying} onClick={(e) => onConfirmClick(e)} onKeyDown={OnIgnoreEnter}>
                        <FontAwesomeIcon icon={faLocationPin} className="fa-fw" aria-hidden="true" />&nbsp;
                        Add Event
                        &nbsp;
                        <KeyboardShortcutTooltip key="xKeyTooltip" show={props.isKeyboardShortcutVisible} keyName="ENTER" />
                    </button>
                </>
            );
        } else {
            return (
                <>
                    <GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />
                    <button id="AddEvent" className="btn btn-success" type="button" disabled={props.isDisabled || props.isPlaying} onClick={(e) => onConfirmClick(e)} onKeyDown={OnIgnoreEnter}>
                        <FontAwesomeIcon icon={faCheck} className="fa-fw" aria-hidden="true" />&nbsp;
                        Confirm
                        &nbsp;
                        <KeyboardShortcutTooltip key="xKeyTooltip" show={props.isKeyboardShortcutVisible} keyName="ENTER" />
                    </button>
                </>
            );
        }
    } else {
        return null;
    }
}
